import { SubscriptionApi } from "@/apis/v2/SubscriptionApi";
import { CustomBackdropController } from "@/components/backdrop/default/v1";
import { customToast } from "@/components/toast/custom-react-toastify/v1";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const QUERY_KEY = 'Subscription';

function handleError(error) {
    if (!error?.response) {
        customToast.error('서버와의 연결이 원활하지 않습니다.');
        return;
    }
    customToast.error(error.response?.data?.message);
}

// 결제 상태는 바뀔 수 있어 열 때마다 다시 불러온다
export function useSubscriptionQuery({ userPageId }) {
    return useQuery({
        queryKey: [QUERY_KEY, userPageId],
        enabled: !!userPageId,
        staleTime: 0,
        queryFn: async () => (await SubscriptionApi.getSubscription({ params: { userPageId } }))?.data?.data,
    });
}

export function useMySubscriptionsQuery({ enabled }) {
    return useQuery({
        queryKey: [QUERY_KEY, 'mine'],
        enabled: !!enabled,
        staleTime: 0,
        queryFn: async () => (await SubscriptionApi.getMySubscriptions())?.data?.data,
    });
}

// 구독 상태가 바뀌면 페이지 정보(planExpiresAt → Pro 표시)도 다시 불러온다
function useSubscriptionMutation(mutationFn, successMessage) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (variables) => (await mutationFn(variables))?.data,
        onSuccess: (data) => {
            customToast.success(successMessage || data?.message);
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
            queryClient.invalidateQueries({ queryKey: ['UserPage'] });
        },
        onError: handleError,
        onMutate: () => CustomBackdropController().showBackdrop(),
        onSettled: () => CustomBackdropController().hideBackdrop(),
    });
}

export function useStartSubscriptionMutation() {
    return useSubscriptionMutation(({ body }) => SubscriptionApi.startSubscription({ body }));
}

export function useChangeCardMutation() {
    return useSubscriptionMutation(({ id, body }) => SubscriptionApi.changeCard({ id, body }));
}

export function useSubscriptionActionMutation() {
    return useSubscriptionMutation(({ id, action }) => SubscriptionApi.runAction({ id, action }));
}
